// extracted by mini-css-extract-plugin
module.exports = {"header":"UserEcgsHeader_header__iJa8Q","mutedTxt":"UserEcgsHeader_mutedTxt__2nUws","cancelCompareBtn":"UserEcgsHeader_cancelCompareBtn__wnWdI"};